var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountsEditUser',{attrs:{"account":_vm.account},on:{"save":function($event){return _vm.save({edit: true})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }